import React from 'react';

const YouTube = {

  _getYouTubeId: (url, currentNoteText) => {
    if (url) {
      var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
      var match = url.match(regExp);
      if (match && match[2].length === 11) {
        return match[2];
      }
    }
    return false;
  },

  _renderYouTubeVideo: (currentNoteText) => {
    var youTubeID;
    youTubeID = YouTube._getYouTubeId(currentNoteText);
    if (youTubeID) {
      return <iframe style={{height: '194px', width: '100%'}} src={`//www.youtube.com/embed/${youTubeID}`} frameBorder="0" allowFullScreen></iframe>;
    }
  }

};

export default YouTube;